export type SafeSearchAnalytics = {
  query_length_bucket: '0' | '1' | '2-3' | '4-7' | '8-15' | '16-31' | '32+';
  query_token_count_bucket: '0' | '1' | '2' | '3-4' | '5+';
  search_correlation_id: string;
};

export type SearchAnalyticsCorrelation = {
  effectiveQuery: string;
  id: string;
};

export function createSearchCorrelationID() {
  if (typeof globalThis.crypto?.randomUUID === 'function') {
    return globalThis.crypto.randomUUID().replaceAll('-', '').slice(0, 16);
  }
  return Array.from({ length: 16 }, () => Math.floor(Math.random() * 16).toString(16)).join('');
}

export function rotateSearchAnalyticsCorrelation(
  current: SearchAnalyticsCorrelation | null,
  query: string,
  createID = createSearchCorrelationID
): SearchAnalyticsCorrelation {
  const effectiveQuery = query.trim().toLowerCase();
  if (current?.effectiveQuery === effectiveQuery) return current;
  return { effectiveQuery, id: createID() };
}

function lengthBucket(length: number): SafeSearchAnalytics['query_length_bucket'] {
  if (length === 0) return '0';
  if (length === 1) return '1';
  if (length <= 3) return '2-3';
  if (length <= 7) return '4-7';
  if (length <= 15) return '8-15';
  if (length <= 31) return '16-31';
  return '32+';
}

function tokenCountBucket(count: number): SafeSearchAnalytics['query_token_count_bucket'] {
  if (count === 0) return '0';
  if (count === 1) return '1';
  if (count === 2) return '2';
  if (count <= 4) return '3-4';
  return '5+';
}

export function deriveSafeSearchAnalytics(
  query: string,
  correlationID: string
): SafeSearchAnalytics {
  const normalized = query.trim();
  const tokenCount = normalized ? normalized.split(/\s+/u).length : 0;
  return {
    query_length_bucket: lengthBucket(Array.from(normalized).length),
    query_token_count_bucket: tokenCountBucket(tokenCount),
    search_correlation_id: correlationID,
  };
}
